import { render, staticRenderFns } from "./MarketingEmailEditor.vue?vue&type=template&id=0af28b50&scoped=true"
import script from "./MarketingEmailEditor.vue?vue&type=script&lang=js"
export * from "./MarketingEmailEditor.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailEditor.vue?vue&type=style&index=0&id=0af28b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af28b50",
  null
  
)

export default component.exports